import { environment } from '../../environments/environment';

/**
 * AP-1161 — ponte entre a redirect_uri do SSO e o roteamento por hash do app.
 *
 * O app usa `RouterModule.forRoot(routes, { useHash: true })`, entao toda rota vive
 * atras de `#`. O SSO exige redirect_uri **sem fragmento** (doc do GET /auth/authorize:
 * "a URI deve ser sem fragmento (#), sem curinga (*) e sem credenciais na URL").
 *
 * Por isso a redirect_uri e um path real (ex.: /sso/callback) e esta funcao, chamada
 * antes do bootstrap do Angular, converte
 *     /sso/callback?code=...&state=...
 * em
 *     /#/sso-poc/callback?code=...&state=...
 *
 * Roda apenas com a feature flag ligada e apenas no path de callback; em qualquer
 * outra rota e um no-op.
 */
export function redirecionarCallbackDoSso(): boolean {
  if (environment.featureFlags?.ssoPoc !== true) {
    return false;
  }

  const callbackPath = environment.sso?.callbackPath;

  if (!callbackPath || window.location.pathname !== callbackPath) {
    return false;
  }

  const query = window.location.search;
  window.location.replace(`${window.location.origin}/#/sso-poc/callback${query}`);

  return true;
}
